import { withStyles } from '@material-ui/core';
import InvoiceTable from './InvoiceTable';
import styles from './styles';

export default withStyles(styles)(InvoiceTable);
